import { Box, styled } from "@mui/material";
import { Fragment } from "react";
import LayoutSetting from "./LayoutSetting";

// Outer content shell: responsive horizontal padding only.
// Width / margin-left are driven by sx from DashboardLayout (breakpoint-aware).
const Wrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  transition: "all 0.3s",
  paddingLeft: "2rem",
  paddingRight: "2rem",
  paddingTop: "0.5rem",
  paddingBottom: "1.5rem",
  [theme.breakpoints.down("xl")]: {
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
  },
  [theme.breakpoints.down("md")]: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
  },
}));

// Fluid inner wrapper – no fixed maxWidth cap so the dashboard
// expands to fill all available horizontal space.
const InnerWrapper = styled(Box)(() => ({
  width: "100%",
  margin: 0,
}));

const LayoutBodyWrapper = ({ children, sx }) => {
  return (
    <Fragment>
      <Wrapper sx={sx}>
        <InnerWrapper>{children}</InnerWrapper>
      </Wrapper>

      <LayoutSetting />
    </Fragment>
  );
};

export default LayoutBodyWrapper;
